<template>
    <div id="msg-container">
    <div>
      <div class="msg-logo logo-left">
        <img src="../assets/chat_head.svg"/>
      </div>
    </div>
    <div style="display: flex; align-items: center;">
      <div id="loading-container">
        <div class="typing-col"></div>
        <div class="typing-col"></div>
        <div class="typing-col"></div>
        <div class="typing-col"></div>
        <div class="typing-col"></div>
      </div>
    </div>
  </div>

</template>

<script>

</script>

<style scoped>
#msg-container {
  display: flex;
  width: 100%;
  margin-bottom: 40px;
}

.msg-logo {
  width: 34px;
  height: 34px;
  box-sizing: border-box;
  padding: 4px;
  margin-top: 5px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--white-dark);
}

.msg-logo img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    max-width: 100%;
    max-height: 100%;
  }

.logo-left {
  margin-right: 12px;
}

.typing-col {
  height: 5px;
  width: 2px;
  background-color: var(--black-default);
}

@keyframes smallBig {
  0%, 100% {
    transform: scaleY(1); /* Original size */
    animation-timing-function: ease-in;
  }
  50% {
    transform: scaleY(2.5); /* Double the height */
    animation-timing-function: ease-out;
  }
}

@keyframes bigSmall {
  0%, 100% {
    transform: scaleY(2.5); /* Original size */
    animation-timing-function: ease-in;
  }
  50% {
    transform: scaleY(1); /* Double the height */
    animation-timing-function: ease-out;
  }
}

#loading-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 38px;
  height: 12.5px;
}

.typing-col:nth-child(odd) {
  animation: bigSmall 0.75s infinite;
  transform-origin: center;
}

.typing-col:nth-child(even) {
  animation: smallBig 0.75s infinite;
  transform-origin: center;
}
</style>